import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { CurrencyInr, Calendar, Users, FileText } from "@phosphor-icons/react";

const fmtInr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);

const Overview = ({ portalMode = false }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div className="text-[#5C6B64]">Loading…</div>;

  return (
    <div>
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-[#5C6B64]">{portalMode ? "Client Portal" : "Practice Command Center"}</p>
        <h1 className="font-serif-display text-4xl mt-2 text-[#0F2E22]">Overview</h1>
      </div>

      <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
        {!portalMode && (
          <StatCard icon={Users} label="Active Clients" value={stats.total_clients} testId="stat-clients" />
        )}
        <StatCard icon={Calendar} label="Pending Deadlines" value={stats.pending_deadlines} testId="stat-deadlines" />
        <StatCard icon={CurrencyInr} label="Paid Revenue" value={fmtInr(stats.paid_revenue)} testId="stat-paid" />
        <StatCard icon={CurrencyInr} label="Outstanding" value={fmtInr(stats.unpaid_revenue)} testId="stat-unpaid" />
        <StatCard icon={FileText} label="Documents" value={stats.documents_count} testId="stat-docs" />
      </div>

      <div className="mt-10">
        <h2 className="font-serif-display text-2xl text-[#0F2E22] mb-4">Upcoming filings</h2>
        <div className="border border-[#E8EAE8] bg-white">
          {stats.upcoming.length === 0 && (
            <div className="p-6 text-sm text-[#5C6B64]">No upcoming deadlines. Enjoy the calm.</div>
          )}
          {stats.upcoming.map((d) => (
            <div
              key={d.id}
              data-testid={`upcoming-${d.id}`}
              className="grid grid-cols-12 gap-4 items-center px-5 py-4 border-b last:border-b-0 border-[#E8EAE8]"
            >
              <div className="col-span-2">
                <span className={`inline-block text-[10px] font-semibold uppercase tracking-widest px-2 py-1 ${badgeCls(d.tax_type)}`}>
                  {d.tax_type}
                </span>
              </div>
              <div className="col-span-6">
                <div className="font-medium text-[#0F2E22]">{d.title}</div>
                <div className="text-xs text-[#5C6B64] mt-0.5">
                  {d.form_code || "—"} {d.client_name ? `· ${d.client_name}` : ""}
                </div>
              </div>
              <div className="col-span-4 text-right font-mono-data text-[#0F2E22]">{d.due_date}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const badgeCls = (t) => {
  switch (t) {
    case "GST":
      return "bg-[#DDE9FF] text-[#1A44A8]";
    case "TDS":
      return "bg-[#FFEBD6] text-[#A54A00]";
    case "ITR":
      return "bg-[#FFD6D6] text-[#A31A1A]";
    case "PT":
      return "bg-[#E5F5E9] text-[#2D7A4D]";
    default:
      return "bg-[#EEE] text-[#333]";
  }
};

const StatCard = ({ icon: Icon, label, value, testId }) => (
  <div className="border border-[#E8EAE8] bg-white p-5" data-testid={testId}>
    <Icon size={20} weight="duotone" className="text-[#0F2E22]" />
    <div className="text-xs uppercase tracking-widest text-[#5C6B64] mt-3">{label}</div>
    <div className="font-mono-data text-2xl text-[#0F2E22] mt-1">{value}</div>
  </div>
);

export default Overview;
